import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import PlatformComponent from "../components/platform/platform.component"

const Platform = () => {
  return (
    <Layout>
      <PlatformComponent />
    </Layout>
  )
}

export default Platform

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
